import SpecTool from './spec-tool';

export default SpecTool;
